import React from "react"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {withFormik} from 'formik';
import {FormattedMessage, injectIntl} from "react-intl";
import {displayErrors, parsePropertiesErrors} from "../../../form-helpers";
import {handleApiResponse} from "../../../crud-actions";
import {setNotification} from "../../../notifications/notifications-actions";
import {downloadDocument} from "../../../../../idoa/app/actions/download";
import {push} from 'connected-react-router'
import SuccessModal from "../success-modal";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {Link} from "react-router-dom";
import ContentShow from "../../content-editor/content-show";
import AttachmentsList from "../attachments-list";
import ContentUnitHeader from "../content-unit-header";
import BaseComponent from "../../base-component";

class InnerForm extends BaseComponent {

    render() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, isSubmitting } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                { displayErrors(errors, 'base') }
                <div className='form-group'>
                    <label><FormattedMessage id='app.uploaded_documents.attribute.file'/></label>
                    <input type='file' className='form-control' id="file" name="file" onChange={(event) => { this.props.setFieldValue("file", event.currentTarget.files[0]); }} onBlur={this.props.handleBlur}/>
                    <label className='small'><FormattedMessage id='app.uploaded_documents.attribute.file.max_size'/></label>
                    { displayErrors(errors, 'file') }
                </div>
                <button type='submit' className='btn btn-primary' disabled={isSubmitting}>{intl.formatMessage({id: 'app.actions.save'})}{this.spinner(isSubmitting)}</button>
            </form>
        )
    }
}

InnerForm = injectIntl(withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        let model = { ...props.resource };
        return model;
    },
    handleSubmit: (values, form) => { form.props.submit(values, form); },
    displayName: 'BasicForm',
})(InnerForm));

class MedicalExamUpload extends BaseComponent {

    constructor(params) {
        super(params);
        this.state = {
            successModal: false
        }
    }

    sendForm = (values, form) => {
        let promise = this.props.assignmentUpload('api/v1', this.props.assignment.id, 'submit_form', values);
        handleApiResponse('ASSIGNMENT', 'ACTION', promise,
            (result) => {
                this.setState({...this.state, successModal: true})
            },
            (result) => {
                this.props.setNotification('warning', this.props.intl.formatMessage({id: 'app.medical_exams.message.upload.fail'}));
                let errors = result.payload.response.errors;
                errors = parsePropertiesErrors(errors, 'data');
                form.setErrors(errors);
            },
            (error) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
                console.log(error);
        }).then(() => {
            form.setSubmitting(false);
        });
    };

    render() {
        let documents = this.props.assignment.employee_data.documents;
        const contentUnit = this.props.assignment.content_unit;
        const isComplete = this.props.assignment.state === 'complete';
        const isSubmitted = this.props.assignment.state === 'submitted';

        const lastAction = this.props.assignment.actions.sort((a, b) => {
            if (a.created_at < b.created_at) return 1;
            if (a.created_at > b.created_at) return -1;
            return 0;
        })[0];

        return (
            <div>
                <ContentUnitHeader contentUnit={contentUnit}/>
                <div className='container'>
                    <ContentShow contentData={contentUnit.content}/>
                    <AttachmentsList contentUnit={contentUnit}/>
                    {
                        lastAction && lastAction.data && lastAction.data.message && lastAction.data.message.length > 0 &&
                        <div>
                            <hr/>
                            <p style={{whiteSpace: 'pre'}}>{ lastAction.data.message }</p>
                        </div>
                    }
                    {
                        isSubmitted &&
                        <div>
                            <hr/>
                            <span className='badge badge-pill badge-gray'><FormattedMessage id='app.content_units.attribute.state.submitted'/></span>
                        </div>
                    }
                    {
                        !isComplete && !isSubmitted &&
                        <div>
                            <hr/>
                            <InnerForm submit={this.sendForm}/>
                            <SuccessModal isOpen={this.state.successModal}>
                                <ModalHeader>{contentUnit.title}</ModalHeader>
                                <ModalBody>
                                    <FormattedMessage id='app.medical_exams.message.upload.success'/>
                                </ModalBody>
                                <ModalFooter>
                                    <Link to='/dashboard' className={'btn btn-green'}><FormattedMessage id='app.actions.ok'/></Link>
                                </ModalFooter>
                            </SuccessModal>
                        </div>
                    }
                </div>
            </div>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        downloadDocument: downloadDocument,
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, matchDispatchToProps)(MedicalExamUpload));
